import { useSelector } from "react-redux";
import ProtectedRoute from "../../components/ProtectedRoute";

import { ROLES } from "../../types";

import OAGUserLandingPage from "./OAGUserLandingPage";
import BondCounselUserLandingPage from "./BondCounselUserLandingPage";
import BondReviewUserLandingPage from "./BondReviewUserLandingPage";
import MacUserLandingPage from "./MacUserLandingPage";
import TWBUserLandingPage from "./TWBUserLandingPage";
import TEAUserLandingPage from "./TEAUserLandingPage";

// Map each role to its corresponding component
const roleToComponentMap = {
  [ROLES.OFFICE_OF_THE_ATTORNEY_GENERAL_USER]: OAGUserLandingPage,
  [ROLES.BOND_COUNSEL_USER]: BondCounselUserLandingPage,
  [ROLES.BOND_REVIEW_USER]: BondReviewUserLandingPage,
  [ROLES.MAC_USER]: MacUserLandingPage,
  [ROLES.TX_WATER_DEV_USER]: TWBUserLandingPage,
  [ROLES.TX_EDU_AGENT_USER]: TEAUserLandingPage,
};

const Home = () => {
  const user = useSelector((state) => state?.user);
  const userRole = user?.userinfo?.role;

  // Get the component based on the user's role
  const LandingPageComponent = roleToComponentMap[userRole];

  // If no component is found for this role, you could optionally return null,
  // or redirect to a 404 / Not Authorized page. For now, we just return null.
  if (!LandingPageComponent) {
    return null;
  }

  return (
    <ProtectedRoute>
      <LandingPageComponent />
    </ProtectedRoute>
  );
};

export default Home;
